//@flow
/* eslint-disable no-unused-vars */
import {createStore, createEvent, type Store, type Event} from 'effector'

declare export function element<P, R>(tag: (props: P) => R, props: P): R
declare export function element(
  tag: 'span',
  props: {
    class?: {[field: string]: string},
    content: Store<string>,
  },
): HTMLInputElement
declare export function element(
  tag: 'input',
  props: {
    max: Store<number>,
    min: Store<number>,
    oninput?: Event<InputEvent>,
    step: Store<number>,
    type: 'range',
    value: Store<number>,
    class?: {[field: string]: string},
  },
): HTMLInputElement
declare export function element(
  tag: 'canvas',
  props: {
    class?: {[field: string]: string},
  },
): HTMLCanvasElement
declare export function element(
  tag: 'div',
  props: {
    class?: {[field: string]: string},
  },
  ...children: *
): HTMLCanvasElement

export function element(tag, props, ...children) {
  if (typeof tag === 'function') return tag(props)
  if (tag === 'input') {
    const e = document.createElement(tag)
    addClasses(e, props)
    e.type = props.type
    props.min.watch(val => {
      e.min = val.toString()
    })
    props.max.watch(val => {
      e.max = val.toString()
    })
    props.value.watch(val => {
      e.value = val.toString()
    })
    props.step.watch(val => {
      e.step = val.toString()
    })
    const oninput = props.oninput || createEvent()
    e.addEventListener('input', oninput, true)
    props.value.on(oninput, (val, e: any) => +e.currentTarget.value)
    return e
  }
  if (tag === 'canvas') {
    const e = document.createElement(tag)
    addClasses(e, props)
    return e
  }
  if (tag === 'div') {
    const e = document.createElement(tag)
    addClasses(e, props)
    const fragment = document.createDocumentFragment()
    children.forEach(child => fragment.appendChild(child))
    e.appendChild(fragment)
    return e
  }
  if (tag === 'span') {
    const e = document.createElement(tag)
    addClasses(e, props)

    let textNode = document.createTextNode('')
    e.appendChild(textNode)
    props.content
      .map(content => document.createTextNode(content))
      .watch(text => {
        e.replaceChild(text, textNode)
        textNode = text
      })
    return e
  }
  throw Error(`wrong tag "${String(tag)}"`)
}
function addClasses(node: any, props: any) {
  if ('class' in props) {
    for (const key in props.class) {
      node.classList.add(props.class[key])
    }
  }
}
